import React from "react";

export default function FaqIconUP() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.1286 16.775L13.6962 6.75305C13.0477 6.06406 11.9528 6.06406 11.3044 6.75305L1.87186 16.775C1.16319 17.528 1.69702 18.7637 2.73108 18.7637H22.2693C23.3034 18.7637 23.8373 17.528 23.1286 16.775Z"
        fill="#F26739"
      />
    </svg>
  );
}
